import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import TableComponent from '../../Table/Table';
import { useSelector } from 'react-redux';

function Commission() {
    const nav = useNavigate()

    const [CommissionGrp, setCommissionGrp] = useState([])
    const [grpPages, setGrpPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false)
    const [affliate, setAffliate] = useState({});
    const StoreUser = useSelector((state) => state.user);
    const [affliatePermission, setAffliatePermission] = useState(false)
    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }
    const getCommissionGrp = async () => {
        setLoading(true)
        const response = await axios.get(window.__CFG.API + "commissions/ListCommissionGroups?page=" + currentPage, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error == null) {
            setLoading(false)
            setCommissionGrp(response.data.Result.Data)
        }
    }
    useEffect(() => {
        getCommissionGrp()
    }, [grpPages, currentPage])
    const columns = React.useMemo(
        () => [
            {
                Header: 'Group ID',
                accessor: 'id',
            },
            {
                Header: 'Currency',
                accessor: 'currency',
            },
            {
                Header: 'Structure',
                accessor: 'structure',
            },
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Members',
                accessor: 'members',
            },
            {
                Header: 'Status',
                accessor: 'status',
            },

        ],
        []
    );
    useEffect(() => { setAffliatePermission(checkPermission(affliate, "aff_edit_commission_groups")) }, [affliate])
    useEffect(() => {
        if (StoreUser != undefined) {
            setAffliate(StoreUser.User)
        }
    }, [affliate])
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    return (
        <>
            <Container>
                <Row className='vh-100'>
                    <Col >

                        <Row className="mt-5 me-4 w-100">

                            <Col lg={3} md={4} sm={5} className=" pt-2" style={{ paddingBottom: 20 }}>
                                <button onClick={() => nav('/affiliate/commission-create-group')} className="btn-com-grp">
                                    Create new group
                                </button>
                            </Col>
                        </Row>

                        <Row className="mt-0 mb-0">
                            <div className="aff-dash-summary-table">

                                <TableComponent columns={columns} data={CommissionGrp} Pages={grpPages} currentPage={currentPage} onPageChange={handlePageChange} ActionLink={(row) => `/affiliate/commission/details?id=` + row.id} navigationColumn={affliatePermission?"id":""} loading={loading} />
                            </div>
                        </Row>




                    </Col>
                </Row>

            </Container>
        </>
    )
}

export default Commission